import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { Observable, from, throwError } from "rxjs";
import { GSTInput, RegisterInput } from '../../class/Register/register';
import { map } from 'rxjs/operators';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  private apiBaseUrl: string = environment.apiUrl;
  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  //getGstURL: string = this.apiBaseUrl + "/Getgst";

  getGstDetails(id: string): Observable<GSTInput> {

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    return this.http.get(`${this.apiBaseUrl}/api/register/GstinfoWithPanCheck/${id}`, httpOptions).pipe(map(m => <GSTInput>m))
  };

  GSTCheck(id: string): Observable<GSTInput> {

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    return this.http.get(`${this.apiBaseUrl}/api/register/GstNumberCheck/${id}`, httpOptions).pipe(map(m => <GSTInput>m))
  };

  MobileCheck(id: string): Observable<RegisterInput> {

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    return this.http.get(`${this.apiBaseUrl}/api/register/CheckPhoneNumber/${id}`, httpOptions).pipe(map(m => <RegisterInput>m))
  };

  EmailCheck(id: string): Observable<RegisterInput> {

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    return this.http.get(`${this.apiBaseUrl}/api/register/CheckUseremail/${id}`, httpOptions).pipe(map(m => <RegisterInput>m))
  };

  EmailCheckExists(data:string):Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    return this.http.get(`${this.apiBaseUrl}/api/register/CheckUserMailExists/${data}`, httpOptions);
  }

  ResendLink(data:any){
    return this.http.post(`${this.apiBaseUrl}/api/register/ResendEmailVerification`,data);
  }


  CreateRegister(formData: FormData): Observable<RegisterInput> {
    if (isPlatformBrowser(this.platformId)) {

      const pec_ipaddress: string = localStorage.getItem('getip') || '0.0.0.0';
      const pec_browser: string = localStorage.getItem('getbrowser') || '-';
      const pec_browser_ver: string = localStorage.getItem('getbrowser_version') || '-';
      const pec_os: string = localStorage.getItem('getostype') || '-';

      formData.append('ipaddress', pec_ipaddress);
      formData.append('browser_ver', pec_browser);
      formData.append('browser', pec_browser_ver);
      formData.append('os', pec_os);

    }
    return this.http.post<RegisterInput>(`${this.apiBaseUrl}/api/register/addregister`, formData)
      .pipe(map(m => <RegisterInput>m));
  }

  GetRegisteredSellers(): Observable<RegisterInput> {

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(`${this.apiBaseUrl}/api/assets/GetRegisteredSellers`, httpOptions).pipe(map(m => <RegisterInput>m))
  };

  bulkUploadRegister(formData: FormData): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {

      const pec_ipaddress: string = localStorage.getItem('getip') || '0.0.0.0';
      const pec_browser: string = localStorage.getItem('getbrowser') || '-';
      const pec_browser_ver: string = localStorage.getItem('getbrowser_version') || '-';
      const pec_os: string = localStorage.getItem('getostype') || '-';

      formData.append('ipaddress', pec_ipaddress);
      formData.append('browser', pec_browser);
      formData.append('browser_ver', pec_browser_ver);
      formData.append('os', pec_os);

    }
    return this.http.post<RegisterInput>(`${this.apiBaseUrl}/api/register/bluk_register`, formData)
    .pipe(map(m => <RegisterInput>m));
  }

}
